import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {getIntValue, isNumber} from "@/utils";
import {KEYS} from "../../../../@excalidraw/packages/excalidraw/keys";
const NumberInput = forwardRef((props:{defaultValue:any,onInputOk:any},ref)=>{
    const [inputValue,setInputValue] = useState('');

    useEffect(() => {
        setInputValue(props.defaultValue);
    }, [props.defaultValue]);
    return<>
        <input value={inputValue} style={{border:'none',width:'100%',textAlign:'center',background:'transparent'}}
               onFocus={(e)=>{
               }}
               onBlur={(e)=>{
                   const szValue = e.currentTarget.value;
                   let newFont = 0;
                   if (szValue=='' || isNaN(szValue)) {
                       setInputValue(props.defaultValue);
                       newFont = 12;
                   }else {
                       let nValue = getIntValue(szValue);
                       if (nValue < 1) {
                           nValue = 1;
                       }
                       setInputValue(nValue);
                       newFont = nValue;
                   }
                   props.onInputOk(newFont);
               }}
               onInput={(e)=>{
                   const szValue = e.currentTarget.value;
                   if (!szValue) {
                       setInputValue('');
                   }
                   if (isNumber(szValue)) {
                       setInputValue(getIntValue(szValue))
                   }
               }}
               onKeyDown={(e)=>{
                   if (e.key == KEYS.ENTER) {
                       e.currentTarget.blur();
                   }
               }}/>
    </>
});

export default NumberInput;